module.exports = __webpack_public_path__ + "img/mall91_logo.0792395e.png";